<!-- <div class="toastr-container">
  @for(toast of toasts; track toast){
    <div class="toast" [ngClass]="toast.type" [@toastAnimation]>
      <div class="toast-icon">
        <img [src]="'assets/icons/toasts' +toast.type+ '.png'" alt="{{ toast.type}} icon">
      </div>
    </div>
    <div class="toast-content">
      <div class="toast-title">{{ toast.title }}</div>
      <div class="toast-message">{{ toast.message }}</div>
    </div>
    <button class="close-btn" (click)="removeToast(toast.id)">x</button>
    <div class="toast-loader"></div>
  }
</div> -->

<div class="toastr-container">
  <div *ngFor="let toast of toasts; trackBy: trackToast" class="toast" [ngClass]="toast.type" [@toastAnimation]>
    <div class="toast-icon">
      <img [src]="getToastIconUrl(toast.type)" alt="{{ toast.type }}">
    </div>

    <div class="toast-content">
      <div class="toast-title">{{ toast.title }}</div>
      <div class="toast-message">{{ toast.message }}</div>
    </div>

    <button class="close-btn" (click)="removeToast(toast.id)">x</button>
    <div class="toast-loader"></div>

  </div>
</div>

